






















import { Vue, Component, Prop } from '$/lib/vueExt';
import { Building }             from '$/entities/Building';

import BuildingModal from '$/screens/App/Buildings/BuildingModal.vue';

@Component({
	components : { BuildingModal },
	model      : { prop : 'unit', event : 'update:unit' },
})
export default class UnitSelector extends Vue {

	@Prop({ default : null })
	readonly unit: string;

	@Prop({ default : null })
	readonly building: Building;

	@Prop({ default : false })
	readonly disabled: boolean;

	@Prop({ default : false })
	readonly plaintext: boolean;

	@Prop({ default : 'md' })
	readonly size: string;

	@Prop({ default : false })
	readonly required: boolean;

	@Prop({ default : false })
	readonly allowNew: boolean;

	localBuilding: Building = null;

	get unitValue() {
		return this.unit;
	}
	set unitValue(value: string) {
		if (value === 'new' && this.allowNew) {
			// Clone the current building for editing, or create a new building if none exists
			this.localBuilding = this.building?.clone() || new Building();
			return;
		}

		this.$emit('update:unit', value);
	}

	get unitsOptions() {
		return (this.building?.unitsSorted ?? []).map(unit => ({
			value : unit.number,
			text  : unit.label,
		}));
	}

	async onBuildingModalClosed() {
		if (this.localBuilding && !this.localBuilding.isNew) {
			this.$emit('update:building', this.localBuilding);
			return;
		}

		this.localBuilding = null;
		this.$emit('update:building', this.localBuilding);
	}

}
